module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.products.index.exportData')))]), _vm._v(" "), [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('el-button', {
    staticClass: "margin-b-20",
    staticStyle: {
      "width": "380px"
    },
    on: {
      "click": _vm.downloadAllProducts
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.products.index.downloadAllProducts')) + "\n        ")])], 1)]], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.products.index.importData')))]), _vm._v(" "), [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('file-pond', {
    ref: "pond",
    attrs: {
      "name": " import_excel",
      "label-idle": _vm.$t('static.products.index.importProducts'),
      "allow-multiple": "false",
      "server": _vm.server
    }
  })], 1)])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e3f8b8b","hasScoped":false}!./src/app/components/productImportExportPopup/productImportExportPopup.html
// module id = 2932
// module chunks = 1